import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { QRButton } from '@base/src/app/models/qr-button.model';
import { Reservation } from '@base/src/app/pages/stats/reservometro/models/reservation.model';

@Component({
  selector: 'app-dialog-delete-reservation',
  templateUrl: './dialog-delete-reservation.component.html',
  styleUrls: ['./dialog-delete-reservation.component.scss']
})
export class DialogDeleteReservationComponent {

  @Input() reservation!: Reservation;
  @Input() message: string = '';
  @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() delete: EventEmitter<boolean> = new EventEmitter<boolean>();

  stepOne: boolean = true;
  stepTwo: boolean = false;
  hasSignal: boolean = false;
  deleteSuccesfull: boolean = false;

  buttonCancel: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Cancelar',
  };

  buttonDelete: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Eliminar',
  };

  buttonNo: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'No',
  }

  buttonYes: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Si',
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message']) {
      if(this.message !== "") {
        this.stepOne = false;
        this.stepTwo = true;
        this.hasSignal = this.message.includes('seña'); 
        this.deleteSuccesfull = !this.hasSignal;

        if(this.message.includes('correctamente')) {
          this.buttonCancel.viewValue = 'Aceptar';
        }
      }
    }
  }

  confirm(): void {
    this.change.emit(true);
    this.deleteSuccesfull = false;
  }

  confirmProcess(): void {
    this.delete.emit(true);
  }

  closeOverlay(): void {
    this.change.emit(false);
  }

}
